<div class="state-switcher h-100 w-100 position-relative">
	<ng-container *ngIf="currentState === STATE_TYPES.LOADING">
		<ng-container
			[ngTemplateOutlet]="loadingStateContent ? loadingStateContent.templateRef : defaultLoadingSpinnerContent"
		>
		</ng-container>
	</ng-container>
	<ng-container *ngIf="currentState === STATE_TYPES.EMPTY">
		<ng-container [ngTemplateOutlet]="emptyStateContent ? emptyStateContent.templateRef : defaultEmptyState">
		</ng-container>
	</ng-container>
	<ng-container *ngIf="currentState === STATE_TYPES.ERROR">
		<ng-container [ngTemplateOutlet]="errorStateContent ? errorStateContent.templateRef : defaultErrorState">
		</ng-container>
	</ng-container>
	<ng-container *ngIf="currentState === STATE_TYPES.DEFAULT">
		<ng-content></ng-content>
	</ng-container>
</div>

<ng-template #defaultEmptyState>
	<app-default-empty-state></app-default-empty-state>
</ng-template>
<ng-template #defaultErrorState>
	<app-default-error-state (reloadWidget)="reloadWidget.emit('')"></app-default-error-state>
</ng-template>
<ng-template #defaultLoadingSpinnerContent>
	<app-default-loading-state></app-default-loading-state>
</ng-template>
